


import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, FreeMode } from "swiper/modules";
import { RxArrowLeft, RxArrowRight, RxArrowTopRight } from "react-icons/rx";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import { useNavigate } from "react-router-dom";
import { ImageData } from "../constants/glassImage";

const GlassImages = () => {
  const navigate = useNavigate(); 

  return (
    <div className="bg-gradient-to-b from-white to-purple-50 py-16">
      {/* Header Section */}
      <div className="text-center mb-12 px-4">
        <h1 className="font-extrabold text-3xl md:text-4xl text-purple-800 mb-4">
          Recently Completed Projects by Powergenic Engineering
        </h1>
        <p className="font-medium text-lg md:text-xl text-blue-800">
          Delivering high-standard solutions for your company
        </p>
      </div>

      {/* Swiper Section */}
      <div className="relative max-w-[90%] lg:max-w-[80%] mx-auto">
        {/* Left Navigation Button */}
        <div className="absolute top-1/2 -left-4 transform -translate-y-1/2 z-10">
          <button
            className="bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition"
            id="swiper-prev"
          >
            <RxArrowLeft size={20} />
          </button>
        </div>

        {/* Right Navigation Button */}
        <div className="absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
          <button
            className="bg-purple-600 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-purple-500 transition"
            id="swiper-next"
          >
            <RxArrowRight size={20} />
          </button>
        </div>

        <Swiper
          breakpoints={{
            340: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          freeMode={true}
          pagination={{ clickable: true }}
          navigation={{
            prevEl: "#swiper-prev",
            nextEl: "#swiper-next",
          }}
          modules={[Navigation, Pagination, FreeMode]}
        >
          {ImageData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="relative shadow-lg rounded-2xl overflow-hidden group h-[300px] md:h-[400px]">
                {/* Background Image */}
                <div
                  className="absolute inset-0 bg-cover bg-center rounded-2xl"
                  style={{ backgroundImage: `url(${item.backgroundImage})` }}
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-20 group-hover:opacity-40 transition duration-300 rounded-2xl" />

                {/* Content */}
                {/* <div className="absolute bottom-4 left-4 text-white z-10">
                  <h3 className="text-lg md:text-xl font-bold">{item.title}</h3>
                  <p className="text-sm md:text-base">{item.description}</p>
                </div> */}

                {/* Arrow Icon */}
                <RxArrowTopRight className="absolute bottom-5 right-5 w-8 h-8 text-white group-hover:text-blue-500 transform group-hover:rotate-45 transition duration-300" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* View More Button */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => navigate("/MoreGlassImages")}
            className="bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-500 transition text-lg font-semibold"
          >
            View More...
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlassImages;
